"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventManager = void 0;
const jquery_1 = __importDefault(require("jquery"));
/**
 * Gestor de eventos del formulario
 */
class EventManager {
    constructor(validationService, onDocumentTypeChange) {
        this.validationService = validationService;
        this.onDocumentTypeChange = onDocumentTypeChange;
    }
    setupEvents() {
        this.setupSubmitButton();
        this.setupDocumentTypeSelector();
    }
    setupSubmitButton() {
        (0, jquery_1.default)(document).on("click", "#continuarOfertaPreliminar", () => {
            (0, jquery_1.default)("#formDatosClienteform").submit();
        });
    }
    setupDocumentTypeSelector() {
        (0, jquery_1.default)("#documentType").on("change", () => {
            const selected = (0, jquery_1.default)("#documentType").val();
            const placeholderMap = {
                nif: "Número NIF"
            };
            const $documentNumber = (0, jquery_1.default)("#documentNumber");
            $documentNumber.attr("placeholder", placeholderMap[selected] || "Número de documento");
            const isEnabled = selected !== "";
            $documentNumber.prop("disabled", !isEnabled);
            if (this.validationService) {
                this.validationService.updateDocumentValidation(selected);
            }
            if (this.onDocumentTypeChange) {
                this.onDocumentTypeChange(selected);
            }
            if ($documentNumber.val()) {
                $documentNumber.valid();
            }
        });
    }
}
exports.EventManager = EventManager;
